import script from "./AccordionList.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionList.vue?vue&type=script&setup=true&lang=js"

import "./AccordionList.vue?vue&type=style&index=0&id=c2b82176&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b82176"]])

export default __exports__